import { createFileRoute, Outlet } from "@tanstack/react-router";

import { TicketNavigationSidebar } from "~/components/layout/sidebars/ticket-navigation-sidebar";
import { SidebarProvider } from "~/components/ui/sidebar";
import {
  QUEUE_SIDEBAR_NAME,
  TICKET_DETAIL_SIDEBAR_NAME,
  TICKET_ICON_NAVIGATION_SIDEBAR_NAME,
  TICKET_NAVIGATION_SIDEBAR_NAME,
} from "~/libs/string";
import { useQueueStore } from "~/stores/queue-store";

export const Route = createFileRoute("/_auth/_app_shell/_ticket-navigation")({
  component: RouteComponent,
});

function RouteComponent() {
  const { queue } = useQueueStore();

  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": queue?.display ? "350px" : "48px",
        } as React.CSSProperties
      }
      sidebarNames={[
        TICKET_NAVIGATION_SIDEBAR_NAME,
        TICKET_ICON_NAVIGATION_SIDEBAR_NAME,
        QUEUE_SIDEBAR_NAME,
        TICKET_DETAIL_SIDEBAR_NAME,
      ]}
    >
      <TicketNavigationSidebar name={TICKET_NAVIGATION_SIDEBAR_NAME} />

      <Outlet />
    </SidebarProvider>
  );
}
